import { invert } from 'lodash';

import { quickFilterType } from '@app/constants';

type DateRangeOptions =
  | typeof quickFilterType.pastYear
  | typeof quickFilterType.pastFiveYears
  | typeof quickFilterType.pastTenYears;

export const getDateRangeOptions = (): {
  options: Record<DateRangeOptions, string>;
  invertedOptions: Record<string, DateRangeOptions>;
} => {
  const currentYear = new Date().getFullYear();

  const options = {
    [quickFilterType.pastYear]: `${currentYear - 1}`,
    [quickFilterType.pastFiveYears]: `${currentYear - 5}`,
    [quickFilterType.pastTenYears]: `${currentYear - 10}`,
  };
  const invertedOptions = invert(options) as Record<string, DateRangeOptions>;

  return { options, invertedOptions };
};
